export let directedl =`
<div>
<p class="ql-align-center" style="text-align: center !important;"><em>RESTRICTED</em></p>

<div class="ql-align-center">
<h3><p>Defence Headquarters </p>
<p>Area 8</p> <p>Abuja</p>
</h3>
</div>
DHQ/00156/3/M 							

<div class="ql-align-center">
<h3><p>09 263156</p>
</h3>
</div>

<p>
<p>Captain (NN) SBM Audu  </p>
<p>Commanding Officer </p>
<p>Nigerian Navy Ship OTOBO</p>
<p>LAGOS </p>

<div class="ql-align-center">
<h3><p style='color:red'>June 2013</p>
</h3>
</div>


<div>

Sir  (1)

<p><u><strong>DISPOSAL OF NIGERIAN NAVY SHIP OTOBO </u></strong></p><br>

<p>1.	 I am directed by the Defence Council to inform you that the recent intensive press speculation as to the imminent disposal of the Nigerian Navy Ship OTOBO is untrue.   A decision as to her future will be made and promulgated by January 2014, but the current plans are that she will remain fully operational until the end of 2013.
</p><br>
<p>2.	A press statement to this effect will be released this week. Meanwhile, you are permitted to divulge this information to your ship's company.
</p>
</div>

<div class="ql-align-center">


<h3>
<p>I am Sir,</p>
<p>Yours obediently</p>
<br>
<p><strong>AKJ AWE</strong></p>
<p>Captain (NN)</p>
<p>for Chief of Naval Staff</p>
</h3>


</div>
</p>






<p class="ql-align-justify" style="text-align: center;"><em style='color: rgb(0, 0, 0); font-family: "Times New Roman"; font-size: medium; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;'>RESTRICTED</em>&nbsp;</p>

</div>

`